import React from 'react'
import { motion } from "framer-motion";
import introthum from '../assets/introImg.png'
import { Link } from 'react-router-dom';


export default function Intro() {
  return (
    <section className="bg-gray-100 py-20 px-4">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">

        {/* Left Image */}
        <motion.div
          initial={{ opacity: 0, x: -80 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="relative"
        >
          <img
            src={introthum}
            alt="About"
            className="rounded-2xl w-full h-auto object-cover"
          />

          {/* Badge */}
          {/* <div className="absolute bottom-5 left-5 ms-bg-secondary text-white px-6 py-4 rounded-xl shadow-lg">
            <h2 className="text-2xl font-bold">5+</h2>
            <p className="text-xs uppercase">Years of Excellence</p>
          </div> */}
        </motion.div>

        {/* Right Content */}
        <motion.div
          initial={{ opacity: 0, x: 80 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <p className="ms-text-secondary uppercase font-semibold text-lg mb-2">
            About Company
          </p>

          <h4 className="text-2xl sm:text-3xl lg:text-2xl font-bold text-gray-900 leading-snug mb-4">
            Helping Salaried Professionals Access Short-Term Credit with Greater Convenience
          </h4>

          <p className="text-gray-600 mb-2 leading-7">
            B4Salary is a digital lending platform designed for professionals seeking a faster and more transparent way to access credit online.
          </p>

          <p className="text-gray-600 mb-2 leading-7">
            Whether it’s navigating temporary cash flow mismatches or managing time-sensitive financial commitments before personal, the platform offers a streamlined digital process with digital documentation and structured verification.
          </p>
          <p className='text-gray-600 mb-2 leading-7'>Loans are facilitated through our RBI-registered NBFC partner, Kisga Leasing and Finance Pvt Ltd, helping ensure a regulated and transparent lending experience.</p>
<h5 className='text-2xl font-semibold pb-2 pt-2'>We focus on:</h5>
          <ul className="flex flex-col gap-2 items-start text-left">
            <li className="flex items-center gap-2">
              <span className="w-2 h-2 bg-orange-500 rounded-full"></span>
              Simple digital application journeys
            </li>

            <li className="flex items-center gap-2">
              <span className="w-2 h-2 bg-orange-500 rounded-full"></span>
              Fast approval and onboarding
            </li>

            <li className="flex items-center gap-2">
              <span className="w-2 h-2 bg-orange-500 rounded-full"></span>
              Secure and scalable fintech APIs
            </li>

            <li className="flex items-center gap-2">
              <span className="w-2 h-2 bg-orange-500 rounded-full"></span>
              Real-time fraud detection system
            </li>
          </ul>


        </motion.div>

      </div>
    </section>
  )
}
